<label
  [for]="labelForId()"
  class="col-form-label col-form-label-sm"
  [ngClass]="{ 'u-required': isRequired(), 'd-none': !label() }"
>
  {{ label() }}
</label>

@if (previewUrl()) {
  <div class="text-center border border-1 rounded-2 position-relative p-2">
    @if (!isReadonly()) {
      <button
        class="btn btn-light text-dark c-button__icon position-absolute top-0 end-0 m-2"
        (click)="clearFile()"
        ngbTooltip="Borrar"
      >
        <span class="material-symbols-rounded">delete</span>
      </button>
    }

    @if (esVideo() || isVideoFile()) {
      <video
        class="img-fluid video-preview"
        controls
        preload="metadata"
        style="max-height: 200px; object-fit: cover"
      >
        <source [src]="previewUrl()" type="video/mp4" />
      </video>
    } @else {
      <img
        mediumZoom
        [src]="previewUrl()!"
        class="img-fluid mb-2"
        alt="preview"
        style="max-height: 200px; object-fit: cover"
      />
    }
  </div>
} @else {
  <div
    class="c-img__container"
    (click)="fileInfo.click()"
    appDragDrop
    (onFileDropped)="uploadFileDrop($event)"
  >
    <input
      hidden
      type="file"
      [id]="labelForId()"
      #fileInfo
      [accept]="allowedFiles()"
      (change)="uploadFile($event)"
    />

    <span class="c-img__icon material-symbols-rounded">
      {{ icon() }}
    </span>

    <span class="c-img__title text-dark mx-3">
      {{ title() }}
    </span>

    <span class="c-img__subtitle mb-0 mx-3">
      Formatos permitidos: {{ extensions() }}
    </span>

    <button type="button" class="c-button__base btn btn-outline-base mt-2">
      Seleccionar archivo
    </button>
  </div>
}
